import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import CompareApplication from "./CompareApplication";
import PublishAction from "./PublishAction";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { getEnv } from "../../Constants/env";

const PublishManagementAction = () => {
  const { action, type } = useParams(); // Retrieve the dynamic action from the URL
  const { data } = useSelector((state: RootState) => state?.applicationDetails);
  const { env } = useSelector((state: any) => state?.createApplication);

  const isPublish = useMemo(() => {
    return type === "publish";
  }, [type]);

  const messageToShow = useMemo(() => {
    const envType = getEnv()?.envtype?.toUpperCase();
    if (envType === "PROD" || envType === "SIT") {
      return env?.toUpperCase();
    }
    return envType;
  }, [env]);

  const renderActionScreen = () => {
    switch (action) {
      case "review":
        return (
          <PublishAction
            breadCrumbLabel="Submit Request"
            header={`Publish to ${data?.app_cmdb_name}`}
            headerText={`Review the application details and the changes to be applied to ${data?.app_cmdb_name} - ${messageToShow} Environment.`}
            selectedTab={9}
            isPublish={isPublish}
          />
        );
      case "view":
        return (
          <PublishAction
            breadCrumbLabel="View"
            header={`Application details`}
            headerText={`View the details of the application version.`}
            selectedTab={9}
            isPublish={isPublish}
            isView={true}
          />
        );
      case "approve":
        return (
          <PublishAction
            breadCrumbLabel="Approve"
            header={`Publish to ${data?.app_cmdb_name}`}
            headerText={`Approving will push the application data to ${data?.app_cmdb_name} - ${messageToShow} Environment. Please provide a short reason for approving or denying.`}
            selectedTab={9}
            isPublish={isPublish}
          />
        );
      case "compare":
        return <CompareApplication />;
      case "restore":
        return (
          <PublishAction
            breadCrumbLabel="Request Approval"
            header="Restore Application"
            headerText="Compare differences between previously published PolicyJsons and then select one to request for restoring. Restoring will replace the current application data."
            selectedTab={isPublish ? 9 : 8}
            isPublish={isPublish}
          />
        );
      case "withdraw":
        return (
          <PublishAction
            breadCrumbLabel="Withdraw"
            header="Withdraw Application"
            headerText="Please give a short reason for withdrawing. Withdrawing will stop the ongoing publish process and the application will remain in the current environment without changes."
            selectedTab={isPublish ? 9 : 8}
            isPublish={isPublish}
          />
        );
      case "import":
        return (
          <PublishAction
            breadCrumbLabel="Import"
            header={`Import to ${data?.app_cmdb_name}`}
            headerText={`Importing will move the application file date into ${data?.app_cmdb_name} - ${messageToShow} Environment, compare changes between the current and new PolicyJsons and please provide a short reason for importing.`}
            selectedTab={9}
            isPublish={isPublish}
          />
        );
      default:
        return <div />;
    }
  };

  return <div>{renderActionScreen()}</div>;
};

export default PublishManagementAction;
